// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_1a_tg","spinnerShowing":"_389k_ _1a_tg","square":"_3fnBP","fade":"_1p31a","white":"_2m1Ab","topLeft":"_5rydd _3fnBP","topRight":"_3DNCi _3fnBP","bottomLeft":"_3Ee-f _3fnBP","bottomRight":"rBMZz _3fnBP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner.css
// module id = 805
// module chunks = 0